// extracted by mini-css-extract-plugin
module.exports = {"price":"_244EzqW0 mb1","free":"_1V8APRgH","customization":"_2rS4nfRN","original-price":"_14xEcKoo ml1","originalPrice":"_14xEcKoo ml1"};